import uniAdminApi from "./api";

const userService = {
  getUsers: async (page = 0, size = 10, facultyId = null) => {
    const params = { page, size };
    if (facultyId) params.facultyId = facultyId;
    const res = await uniAdminApi.get("/university-admin/users", { params });
    return res.data;
  },

  getUser: async (id) => {
    const res = await uniAdminApi.get(`/university-admin/users/${id}`);
    return res.data;
  },

  toggleUserActive: async (id) => {
    const res = await uniAdminApi.post(
      `/university-admin/users/${id}/toggle-active`,
    );
    return res.data;
  },

  toggleUserBan: async (id) => {
    const res = await uniAdminApi.post(
      `/university-admin/users/${id}/toggle-ban`,
    );
    return res.data;
  },

  changeUserStatusAndRole: async (id, data) => {
    const res = await uniAdminApi.put("/university-admin/users/change-status-and-role", {
      userId: id,
      emailVerified: data.emailVerified,
      isActive: data.active,
      isBanned: data.banned,
      role: data.role.toUpperCase(),
    });
    return res.data;
  },
};

export default userService;
